export let baseUrl = '';
if (process.env.NODE_ENV == 'production') {
  if (process.env.VUE_APP_REALEASE === 'test') {
    baseUrl = 'http://activities-test.mini.me/highSchool';
  } else {
    baseUrl = 'https://ncsgdc.mini1.cn/highSchool';
  }
} else {
  baseUrl = '';
}
